const delay = (sec: number) => {
  return new Promise(function (resolve) {
    setTimeout(resolve, sec * 1000);
  });
};

export default delay;
